import { ref } from "vue";
import { useStoreCompat } from "./useStoreCompat";

export function useActuacionesOrder(getData) {
  const store = useStoreCompat();

  const order = ref({
    FechaCreacion: {
      field: "exp_pre_Actuacion.FechaCreacion",
    },
    Numero: {
      field: "exp_pre_Actuacion.Numero",
    },
  });

  const orderColumns = ref({});

  const setOrderBy = (field) => {
    const localOrder = { ...order.value };
    if (!localOrder[field].mode) {
      localOrder[field] = {
        mode: false,
        icon: "pi pi-sort-alt",
      };
    }

    switch (localOrder[field].mode) {
      case false:
        localOrder[field].mode = "ASC";
        localOrder[field].icon = "pi pi-sort-alpha-up";
        break;
      case "ASC":
        localOrder[field].mode = "DESC";
        localOrder[field].icon = "pi pi-sort-alpha-down-alt";
        break;
      case "DESC":
        localOrder[field].mode = false;
        localOrder[field].icon = "pi pi-sort-alt";
        break;
    }

    setOrder(localOrder);
  };

  const setOrder = async (data) => {
    order.value = data;
    let orderArr = [];

    for (let k in data) {
      if (!data[k].mode) continue;
      let field = data[k].field || k;
      orderArr.push(`${field} ${data[field].mode}`);
    }

    let finalOrder = orderArr.length > 0 ? orderArr.join(",") : null;
    await store.dispatch("sumarioList/setOrder", finalOrder);
    getData();
  };

  return {
    order,
    orderColumns,
    setOrder,
    setOrderBy,
  };
}
